import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { FiPhone, FiMapPin, FiMail, FiClock, FiMessageCircle } from 'react-icons/fi';
import Navigation from './Navigation';
import Footer from './Footer';
import logo from '../lasmari-wordmark.png';
import { PHONE, WHATSAPP, WHATSAPP_DISPLAY, EMAIL, SITE_URL, DEFAULT_OG_IMAGE } from '../config/seo-data';

const fadeIn = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6 }
};

const SEOPageLayout = ({
  title,
  description,
  keywords,
  canonical,
  ogImage = DEFAULT_OG_IMAGE,
  children
}) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {keywords && <meta name="keywords" content={keywords} />}
        <link rel="canonical" href={canonical} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={ogImage} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
      </Helmet>

      <div className="min-h-screen bg-white text-[#1a1012] font-sans">
        {/* Unified Navigation */}
        <Navigation />

        {/* Page Content */}
        <main>
          {children}
        </main>

        {/* CTA Section */}
        <section className="relative py-20 bg-[#ba1609] border-t border-[#8e1107]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <motion.h2
              {...fadeIn}
              viewport={{ once: true }}
              whileInView="animate"
              initial="initial"
              className="text-3xl lg:text-4xl font-light text-white mb-4"
            >
              Ready to Book Your Transfer?
            </motion.h2>
            <p className="text-white/85 text-lg mb-8 font-light">
              Fixed prices, flight monitoring, Mercedes-Benz comfort. Book in 60 seconds.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/booking"
                className="bg-white text-[#ba1609] px-8 py-3 rounded-full font-medium hover:bg-[#fbeceb] transition-colors text-lg"
              >
                Book Online
              </Link>
              <a
                href={`https://wa.me/${WHATSAPP}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 border border-white/30 text-white px-8 py-3 rounded-full hover:bg-white/10 transition-colors"
              >
                <FiMessageCircle className="w-5 h-5" />
                WhatsApp Us
              </a>
            </div>
          </div>
        </section>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default SEOPageLayout;
